import React, { useState, memo } from "react"
import { useForm } from "react-hook-form"
import parse from "html-react-parser"
import axios from "axios"
import FormButtonRed from "../../../buttons/formButtonRed/formButtonRed"
import OptimizedImage from "../../../../components/ImageShow/OptimizedImage"
import HRIcon from "../../../svg/new/HR"
import BusinessIcon from "../../../svg/new/Business"
import * as style from "./footerBottom.module.css"

const FooterBottom = ({ footerMenu, homeData }) => {
  const [msg, setMsg] = useState("")
  const {
    contactUsText,
    contactUsaNumber,
    inquiryEmail,
    hrEmail,
    usaOfficeText,
    floridaText,
    floridaContactAddress,
    contactNumber,
    subscribeSectionText,
  } = homeData

  const [loading, setloading] = useState(false)
  const [isHover, setisHover] = useState({
    india: false,
    usa: true,
    usa2: false,
  })

  const handleMouseEnter = key => {
    if (key == "india") {
      setisHover({
        india: true,
        usa: false,
        usa2: false,
      })
    } else if (key == "usa2") {
      setisHover({
        india: false,
        usa: false,
        usa2: true,
      })
    } else {
      setisHover({
        india: false,
        usa: true,
        usa2: false,
      })
    }
  }

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()

  const onSubmit = value => {
    let formData = new FormData()
    formData.append("email", value?.email)

    setloading(true)
    axios({
      method: "post",
      url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/newsubscriber/`,
      data: formData,
      // headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        if (response?.data?.success) {
          setMsg(
            "Thank you for subscribing. We will keep you posted with latest updates."
          )
          setTimeout(() => {
            setMsg("")
          }, 8000)
          reset({
            email: "",
          })
        } else {
          alert("Please try again in sometime \n \nSomething went wrong!")
        }
      })
      .catch(error => {
        alert("Please try again in sometime \n \nSomething went wrong!")
        console.error("error: ", error)
      })
      .finally(() => {
        setloading(false)
      })
  }

  const emailRequired = errors.email && errors.email.type === "required"
  const emailPattern = errors.email && errors.email.type === "pattern"

  return (
    <div className="row">
      <div className={style.footer_wrapper}>
        <div
          className={`${style.footerLeft}
                `}
        >
          <div className={` ${style.mapBox} `}>
            <OptimizedImage imageData="/images/Map.png" alt="map" />
            <div
              onMouseMove={() => handleMouseEnter("india")}
              onClick={e => {
                e.preventDefault()
              }}
              className={`${style.roundDiv} ${style.india} ${isHover.india ? style.current : style.data
                } `}
            >
              <div className={style.center}></div>
              <div className={style.down}></div>
              <div className={style.up}></div>
              <div className={`${style.lines}`}></div>
            </div>
            <div
              onMouseMove={() => handleMouseEnter("usa")}
              onClick={e => {
                e.preventDefault()
              }}
              className={`${style.roundDiv} ${style.usa} ${isHover.usa ? style.current : style.data
                } `}
            >
              <div className={style.center}></div>
              <div className={style.down}></div>
              <div className={style.up}></div>
              <div className={`${style.lines} ${style.usaLine}`}></div>
            </div>
            <div
              onMouseMove={() => handleMouseEnter("usa2")}
              onClick={e => {
                e.preventDefault()
              }}
              className={`${style.roundDiv} ${style.usa2} ${isHover.usa2 ? style.current : style.data
                } `}
            >
              <div className={style.center}></div>
              <div className={style.down}></div>
              <div className={style.up}></div>
              <div className={`${style.lines} ${style.usa2Line}`}></div>
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <div
              className={`${style.addressBox} ${isHover.india ? style.current : ""
                }  `}
            >
              <div className={`${style.footer_col}`}>
                <div
                  className={style.footer_title}
                  style={{ color: "#E95444" }}
                >
                  India
                </div>
                <div className={`${style.footer_add}`}>
                  <div className={style.ft_col_inner}>
                    <p className={style.address}>
                      <span> Ahmedabad </span> <br />
                      10th Floor, Ashridhar Athens, Shivranjani Cross Rd,
                      Ahmedabad - 380015
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${style.addressBox} ${style.usaLine} ${isHover.usa ? style.current : ""
                }  `}
            >
              <div className={`${style.footer_col}`}>
                <div
                  className={style.footer_title}
                  style={{ color: "#E95444" }}
                >
                  {usaOfficeText}
                  {/* India  */}
                </div>
                <div className={`${style.footer_add}`}>
                  <div className={style.ft_col_inner}>
                    <p className={style.address}>
                      <span> {floridaText} </span> <br />
                      {parse(`${floridaContactAddress} `)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${style.addressBox} ${isHover.usa2 ? style.current : ""
                }  ${style.usa2Line} `}
            >
              <div className={`${style.footer_col}`}>
                <div
                  className={style.footer_title}
                  style={{ color: "#E95444" }}
                >
                  {usaOfficeText}
                  {/* India  */}
                </div>
                <div className={`${style.footer_add}`}>
                  <div className={style.ft_col_inner}>
                    <p className={style.address}>
                      <span> Dallas </span> <br />
                      17440 Dallas Parkway suite 130, Dallas, TX 75287, USA.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={style.footerRight}>
          <div className={style.footer_col}>
            <div className={style.ft_col_inner}>
              <div className={style.footer_title}>{contactUsText}</div>
              <div className={style.footerRightinner}>
                <div className={style.contactNumber}>
                  <p>
                    <span> USA : </span>
                    <span>
                      <a href={`tel:${contactUsaNumber}`}>{contactUsaNumber}</a>{" "}
                      <br />
                      <a href={`tel:${contactNumber}`}>{contactNumber}</a>
                    </span>
                  </p>
                </div>
                <div className={style.contactMail}>
                  <p>
                    <BusinessIcon />{" "}
                    <a href={`mailto: ${inquiryEmail}`}>{inquiryEmail}</a>
                  </p>
                  <p>
                    <HRIcon /> <a href={`mailto: ${hrEmail}`}>{hrEmail}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={style.footer_col}>
            <div className={style.ft_col_inner}>
              <div className={style.footer_title}>
                {parse(`${subscribeSectionText} `)}
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={style.subscribe_wrap}>
                  <div className={style.subscribe_input_wrap}>
                    <input
                      type="email"
                      placeholder="Enter your email here"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      })}
                    />
                    {emailRequired && (
                      <div
                        style={{
                          color: "#e95444",
                          marginTop: "5px",
                          display: "inline-block",
                        }}
                      >
                        Email is Required!!{" "}
                      </div>
                    )}
                    {emailPattern && (
                      <div
                        style={{
                          color: "#e95444",
                          marginTop: "5px",
                          display: "inline-block",
                        }}
                      >
                        Please Enter Valid Email{" "}
                      </div>
                    )}
                  </div>
                  <FormButtonRed
                    btnText={loading ? "loading..." : "Subscribe"}
                    disable={loading}
                  />
                </div>
              </form>
              {msg && (
                <div
                  style={{
                    color: "green",
                    marginTop: "5px",
                    display: "inline-block",
                  }}
                >
                  {msg}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default memo(FooterBottom)
